import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Table,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { useState, React, useEffect, useContext, useMemo } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { MainContext } from "context/MainContext.js";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const Acknowledgements = () => {
  const history = useHistory();
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["versions.licenses.display"])) {
      history.push({ pathname: "/" });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({ pathname: "/auth/terms" });
    }
  }, []);

  const [sortOrder, setSortOrder] = useState({
    column: "organization",
    order: "asc",
  });

  const changeSortOrder = (columnName) => {
    if (sortOrder.column == columnName) {
      setSortOrder({
        ...sortOrder,
        order: sortOrder.order == "asc" ? "desc" : "asc",
      });
    } else {
      setSortOrder({ column: columnName, order: "asc" });
    }
  };

  const licenses = useMemo(
    () => [
      // ── Spring Boot ────────────────────────────────────────────────
      {
        organization: "org.springframework.boot",
        name: "spring-boot-starter-web",
        version: "3.2.2",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.springframework.boot",
        name: "spring-boot-starter-test",
        version: "3.2.2",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.springframework.boot",
        name: "spring-boot-starter-data-jpa",
        version: "3.2.2",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.springframework.boot",
        name: "spring-boot-starter-security",
        version: "3.2.2",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.springframework.boot",
        name: "spring-boot-starter-cache",
        version: "3.2.2",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.springframework.boot",
        name: "spring-boot-starter-validation",
        version: "3.2.2",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.projectlombok",
        name: "lombok",
        version: "1.18.36",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "org.postgresql",
        name: "postgresql",
        version: "42.5.1",
        license: "https://opensource.org/license/bsd-2-clause",
      },
      {
        organization: "org.flywaydb",
        name: "flyway-core",
        version: "9.12.0",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.asynchttpclient",
        name: "async-http-client",
        version: "2.12.3",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.apache.httpcomponents.core5",
        name: "httpcore5",
        version: "5.2.1",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "javax.cache",
        name: "cache-api",
        version: "1.1.1",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.ehcache",
        name: "ehcache",
        version: "3.10.8",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "net.jradius",
        name: "jradius-core",
        version: "1.1.5",
        license: "https://www.gnu.org/licenses/lgpl-3.0.en.html",
      },
      {
        organization: "net.jradius",
        name: "jradius-dictionary",
        version: "1.1.5",
        license: "https://www.gnu.org/licenses/lgpl-3.0.en.html",
      },
      {
        organization: "com.fasterxml.jackson.core",
        name: "jackson-core",
        version: "2.15.0-rc2",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "com.fasterxml.jackson.dataformat",
        name: "jackson-dataformat-xml",
        version: "2.14.1",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "com.github.eirslett",
        name: "frontend-maven-plugin",
        version: "1.12.1",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.springdoc",
        name: "springdoc-openapi-starter-webmvc-ui",
        version: "2.6.0",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "commons-validator",
        name: "commons-validator",
        version: "1.7",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.thymeleaf",
        name: "thymeleaf",
        version: "3.1.1.RELEASE",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.apache.commons",
        name: "commons-csv",
        version: "1.10.0",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.apache.poi",
        name: "poi",
        version: "5.2.3",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.apache.poi",
        name: "poi-ooxml",
        version: "5.2.3",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.apache.commons",
        name: "commons-email",
        version: "1.5",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.bouncycastle",
        name: "bcprov-jdk18on",
        version: "1.80",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "net.javacrumbs.shedlock",
        name: "shedlock-spring",
        version: "7.2.1",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "net.javacrumbs.shedlock",
        name: "shedlock-provider-jdbc-template",
        version: "7.2.1",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "org.springframework.retry",
        name: "spring-retry",
        version: "2.0.5",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      // ── React / npm ────────────────────────────────────────────────
      {
        organization: "npm",
        name: "@fortawesome/fontawesome-svg-core",
        version: "6.5.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "@fortawesome/free-solid-svg-icons",
        version: "6.5.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "@fortawesome/react-fontawesome",
        version: "0.2.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "@react-pdf-viewer/core",
        version: "3.12.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "bootstrap",
        version: "5.2.3",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "chart.js",
        version: "4.1.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "classnames",
        version: "2.3.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "i18next",
        version: "24.1.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "i18next-http-backend",
        version: "3.0.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "jwt-decode",
        version: "3.1.2",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "match-sorter",
        version: "6.3.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "moment",
        version: "2.29.3",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "moment-timezone",
        version: "0.5.42",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "nouislider",
        version: "14.6.3",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "papaparse",
        version: "5.4.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "pdfjs-dist",
        version: "3.11.174",
        license: "https://www.apache.org/licenses/LICENSE-2.0",
      },
      {
        organization: "npm",
        name: "perfect-scrollbar",
        version: "1.5.5",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "prop-types",
        version: "15.8.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react",
        version: "18.x",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-big-calendar",
        version: "0.40.7",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-bootstrap-sweetalert",
        version: "5.2.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-bootstrap-switch",
        version: "15.5.3",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-chartjs-2",
        version: "5.1.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-datetime",
        version: "3.1.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-dom",
        version: "18.x",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-i18next",
        version: "15.1.4",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-icons",
        version: "4.8.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-idle-timer",
        version: "5.5.3",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-image-gallery",
        version: "1.2.11",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-loading-overlay",
        version: "1.0.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-notification-alert",
        version: "0.0.13",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-router-dom",
        version: "5.2.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-scripts",
        version: "5.0.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-select",
        version: "3.1.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-table",
        version: "7.8.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-table-plugins",
        version: "1.3.4",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-tagsinput",
        version: "3.19.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-three-state-checkbox",
        version: "3.0.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-timezone-select",
        version: "1.4.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-toastify",
        version: "9.1.1",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "react-tooltip",
        version: "5.21.5",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "reactstrap",
        version: "9.1.6",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "sass",
        version: "1.53.0",
        license: "https://opensource.org/licenses/MIT",
      },
      {
        organization: "npm",
        name: "xlsx",
        version: "0.18.5",
        license: "https://opensource.org/licenses/Apache-2.0",
      },
    ],
    [],
  );

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink to={{ pathname: "/admin/dashboard" }}>
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Acknowledgements</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Open Source Licenses</CardTitle>
              </CardHeader>
              <CardBody>
                <Table striped>
                  <thead className="text-primary">
                    <tr>
                      <th onClick={() => changeSortOrder("organization")}>
                        Organization{" "}
                        {sortOrder.column === "organization" &&
                        sortOrder.order === "asc"
                          ? "↑"
                          : ""}
                        {sortOrder.column === "organization" &&
                        sortOrder.order === "desc"
                          ? "↓"
                          : ""}
                      </th>
                      <th onClick={() => changeSortOrder("name")}>
                        Name{" "}
                        {sortOrder.column === "name" &&
                        sortOrder.order === "asc"
                          ? "↑"
                          : ""}
                        {sortOrder.column === "name" &&
                        sortOrder.order === "desc"
                          ? "↓"
                          : ""}
                      </th>
                      <th onClick={() => changeSortOrder("version")}>
                        Version{" "}
                        {sortOrder.column === "version" &&
                        sortOrder.order === "asc"
                          ? "↑"
                          : ""}
                        {sortOrder.column === "version" &&
                        sortOrder.order === "desc"
                          ? "↓"
                          : ""}
                      </th>
                      <th>License</th>
                    </tr>
                  </thead>
                  <tbody>
                    {licenses
                      .sort((a, b) => {
                        if (sortOrder.order == "asc") {
                          const nameCompare = a[sortOrder.column].localeCompare(
                            b[sortOrder.column],
                          );
                          if (nameCompare !== 0) return nameCompare;
                        } else {
                          const nameCompare = b[sortOrder.column].localeCompare(
                            a[sortOrder.column],
                          );
                          if (nameCompare !== 0) return nameCompare;
                        }
                        return 0;
                      })
                      .map((license, i) => (
                        <tr key={i}>
                          <td>{license.organization}</td>
                          <td>{license.name}</td>
                          <td>{license.version}</td>
                          <td>
                            <a
                              href={license.license}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {license.license}
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Acknowledgements;
